import React from 'react';

const TapeLanding = () => {
  const apps = [
    { name: "Vaak", desc: "Interactive AI language learning platform.", status: "Live", icon: "/assets/vaak_appstore_official.jpg" },
    { name: "Math Guru", desc: "3D spatial STEM & AI problem solver.", status: "Live", icon: "/assets/math_appstore_official.jpg" },
    { name: "Tape — Record", desc: "AI-driven meeting intelligence and audio capture.", status: "Live", icon: "/assets/tape_appstore_official.jpg" },
    { name: "Savanna United", desc: "Enterprise HOA community governance platform.", status: "Live", icon: "/assets/savanna.png" }
  ];

  return (
    <div className="landing-page" style={{ background: 'var(--bg-color)', color: 'var(--text-primary)' }}>
      {/* Hero Section */}
      <section className="section-padding" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <div className="container-custom">
          <div className="row align-items-center">
            <div className="col-lg-6 animate-fade-in">
              <div className="glass" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.8rem', padding: '0.6rem 1.2rem', borderRadius: '100px', fontSize: '0.85rem', color: '#3b82f6', marginBottom: '2rem', fontWeight: 700, border: '1px solid rgba(59, 130, 246, 0.3)' }}>
                <img src="/assets/tape_appstore_official.jpg" alt="" style={{ width: '20px', height: '20px', borderRadius: '4px' }} />
                ✨ POWERED BY ADVANCED AI
              </div>
              <h1 className="gradient-text" style={{ fontSize: '5rem', lineHeight: '1.05', marginBottom: '2rem' }}>
                Meetings, <br />Intelligently <br />Documented.
              </h1>
              <p style={{ fontSize: '1.4rem', color: 'var(--text-secondary)', marginBottom: '3rem', maxWidth: '550px' }}>
                Tape transforms your conversations into actionable intelligence with absolute privacy.
              </p>
              <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                <a href="#features" className="btn-primary">Get Started</a>
                <a href="#ecosystem" className="glass" style={{ padding: '1rem 2rem', borderRadius: '14px', color: '#fff', textDecoration: 'none', fontWeight: 600, border: '1px solid rgba(255,255,255,0.2)' }}>
                  The Ecosystem
                </a>
              </div>
            </div>
            
            <div className="col-lg-6 animate-fade-in mt-5 mt-lg-0">
              <div style={{ position: 'relative' }}>
                <div style={{ 
                  position: 'absolute', 
                  top: '50%', 
                  left: '50%', 
                  transform: 'translate(-50%, -50%)',
                  width: '130%', 
                  height: '130%', 
                  background: 'radial-gradient(circle, var(--accent-glow) 0%, transparent 70%)',
                  zIndex: -1,
                  opacity: 0.4
                }}></div>
                <div className="glass" style={{ borderRadius: '40px', overflow: 'hidden', border: '1px solid var(--glass-border)', boxShadow: '0 30px 60px -12px rgba(0,0,0,0.5)' }}>
                  <img 
                    src="/tape_hero_preview.png" 
                    alt="Tape AI Workspace" 
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Workshop Ecosystem Section */}
      <section id="ecosystem" className="section-padding" style={{ background: 'rgba(255,255,255,0.01)', borderTop: '1px solid var(--glass-border)' }}>
        <div className="container-custom">
          <div style={{ textAlign: 'center', marginBottom: '6rem' }}>
            <h2 style={{ fontSize: '3.5rem', marginBottom: '1.5rem' }}>The Workshop Ecosystem</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '1.3rem', maxWidth: '700px', margin: '0 auto' }}>
              A specialized suite of intelligent tools designed to elevate your professional workflow.
            </p>
          </div>

          <div className="row g-4">
            {apps.map((app, index) => (
              <div key={index} className="col-md-6 col-lg-3">
                <div className="glass glass-card h-100" style={{ position: 'relative' }}>
                  {app.status === 'Coming Soon' && (
                    <span style={{ fontSize: '0.65rem', background: 'rgba(59, 130, 246, 0.2)', padding: '0.3rem 0.8rem', borderRadius: '100px', position: 'absolute', top: '1.5rem', right: '1.5rem', color: '#3b82f6', fontWeight: 700, border: '1px solid rgba(59, 130, 246, 0.3)' }}>
                      SOON
                    </span>
                  )}
                  <div style={{ 
                    width: '70px', 
                    height: '70px', 
                    background: app.icon ? 'transparent' : 'rgba(255,255,255,0.05)', 
                    borderRadius: '20px', 
                    marginBottom: '2rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    boxShadow: app.icon ? '0 10px 20px rgba(0,0,0,0.3)' : 'none'
                  }}>
                    {app.icon ? (
                      <img src={app.icon} alt={app.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <span style={{ fontSize: '2rem' }}>📈</span>
                    )}
                  </div>
                  <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>{app.name}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem', lineHeight: '1.6' }}>{app.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="section-padding">
        <div className="container-custom">
          <div style={{ textAlign: 'center', marginBottom: '6rem' }}>
            <h2 style={{ fontSize: '3.5rem', marginBottom: '1.5rem' }}>Intelligence in every word.</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '1.3rem' }}>Precision-engineered for the most demanding professionals.</p>
          </div>

          <div className="row g-5">
            <div className="col-lg-4">
              <div className="glass glass-card">
                <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🛡️</div>
                <h3 style={{ marginBottom: '1.2rem', color: '#3b82f6' }}>Zero-Knowledge AI</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>Your data is processed ephemerally. We never train global models on your private conversations.</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="glass glass-card">
                <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🧠</div>
                <h3 style={{ marginBottom: '1.2rem', color: '#3b82f6' }}>Neural Summaries</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>High-fidelity extraction of key decisions, action items, and context-aware summaries.</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="glass glass-card">
                <div style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>🔄</div>
                <h3 style={{ marginBottom: '1.2rem', color: '#3b82f6' }}>Seamless Sync</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>Instant, encrypted synchronization across your entire Apple ecosystem with biometric locking.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-padding" style={{ marginBottom: '4rem' }}>
        <div className="container-custom">
          <div className="glass glass-card" style={{ textAlign: 'center', padding: '6rem 2rem', background: 'radial-gradient(circle at top right, rgba(59, 130, 246, 0.15), transparent), rgba(255,255,255,0.02)' }}>
            <h2 style={{ fontSize: '4rem', marginBottom: '2rem' }}>Elevate your intelligence.</h2>
            <p style={{ fontSize: '1.4rem', color: 'var(--text-secondary)', marginBottom: '4rem', maxWidth: '650px', margin: '0 auto 4rem' }}>
              Experience the future of meeting documentation today. Secure, private, and powerful.
            </p>
            <a href="#" className="btn-primary" style={{ fontSize: '1.3rem', padding: '1.2rem 3.5rem' }}>Download on App Store</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TapeLanding;
